<template lang="pug">
  v-dialog(v-model="showing" max-width=600 scrollable)
    template(v-slot:activator="{on}")
      slot(name="activator" :on="on")
        v-btn(v-on="on") test
    template(v-slot:default="courseChoose")
      v-card
        v-card-title Assign course configuration
        assign-body(
          :location.sync="location"
        )
        v-card-actions
          v-spacer
          v-btn(color="error" text @click="toggle") Close
          v-btn(color="success" text @click="submit") Apply
</template>
<script>
import errorsMixin from '@/mixins/errors.mixin'
import FormErrors from "@/util/form-errors"
import { mapGetters, mapActions } from 'vuex'
import { DATETIME, REQUIRED, DATE_INDIAN } from '@/util/validation-rules'
import CMLocationConfigModel from "../../classes/CMLocationConfigModel"
import CMLocationValidator from "../../classes/CMLocationValidator"

export default {
  mixins: [errorsMixin],
  props: {
    ID: Number,
    value: null,
    multiple: Boolean,
    activeItems: Array
  },
  data: () => ({
    location: null,
    showing: false
  }),

  computed: {
    ...mapGetters({
      locations: 'locationConfigurations/items'
    }),

    formattedLocations() {
      if(!this.locations) return []
      return this.locations.map(location => {
        return {
          ...location,
          textToShow: `${location.name}`
        }

      })
    }
  },

  inject: ['svc'],

  methods: {
    toggle() {
      this.showing = !this.showing
    },

    Svc() {
      return this.svc()
    },

    submit() {
      if(this.multiple) return this.sendMultiple()
      this.send()
    },

    async send(payload) {
      try {
        let res = await this.svc().updateCourseConfiguration(this.ID, this.location)
        this.$notify({text: 'Success', type: 'success'})
        this.toggle()
        this.$emit('create')
      } catch (error) {
        console.log(error)
        this.processErrorWithForm(error, {
          redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE,
          formErrors: this.formErrors, 
          apiAttributes: this.apiAttrs
        });
      }
    },

    async sendMultiple(payload) {
      try {
        let ids = this.activeItems.map(item => item.ID)
        let res = await this.svc().courseConfigurationBulk(ids, this.location)
        this.$notify({text: 'Success', type: 'success'})
        this.toggle()
        this.$emit('create')
      } catch (error) {
        console.log(error)
        this.processErrorWithForm(error, {
          redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE,
          formErrors: this.formErrors, 
          apiAttributes: this.apiAttrs
        });
      }
    },

    reset() {
      this.location = null
    },
  },

  watch: {
    showing(isShowing) {
      if(this.multiple) return
      if(isShowing) this.location = this.value
      if(!isShowing) {
        this.reset()
        
        return
      }
    }
  },

  components: {
    assignBody: ()=> import('./CMAssignCourseConfigurationBody.vue')
  }
}
</script>
